<template>
  <div class="container-fluid page-title">
    <!-- <Labels :title="title" :main="desc" /> -->

    <div class="row starter-main">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="container-header">
              <img
                class="img-fluid for-light m-r-20"
                src="@/assets/images/svg-img/finance-coin.svg"
                alt=""
              />
              <div class="text">
                <h6>{{ detailDetail }} Moonshot Impact</h6>
                <span class="subtitle">Last Updated: Yesterday</span>
              </div>
            </div>
          </div>
          <div style="align-items: start !important" class="row">
            <div class="col-md-12">
              <div class="card-body">
                <ImpactComponent
                  @sendData="handleFormSubmitted"
                  ref="childComponent"
                  :dataProfit="dataImpact"
                  :series3="rawSeries"
                  :options3="options3"
                  :dataImproved="dataImproved"
                  :dataNetZero="dataNetZero"
                />
              </div>
            </div>
            <!-- <div
              style="
                background-color: #f2f2f2;
                border-radius: 10px;
                padding: 2%;
              "
              class="col-md-4"
            >
              <div class="card">
                <div class="card-header">
                  <div class="container-header">
                    <div class="text">
                      <h6 class="title">IMPROVEMENT ASPIRATION</h6>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div
                    v-for="(item, id) in dataImproved"
                    :key="id"
                    class="card card_white mb_12"
                  >
                    <div class="sub_title_2">{{ item.metricName }}</div>
                    <div
                      style="justify-content: space-between"
                      class="d-flex align-items-center"
                    >
                      <div class="data_text">{{ item.value }}</div>
                      <div
                        style="flex: 1; text-align: right"
                        class="d-flex ms-2"
                      >
                        <div
                          v-if="item.achievement !== null"
                          class="d-inline-flex align-items-center me-2"
                          :class="
                            item.achievementStatus === 'DOWN'
                              ? 'badge_red'
                              : 'badge_green'
                          "
                        >
                          <IconSvg
                            :color="
                              item.achievementStatus === 'DOWN'
                                ? 'red'
                                : 'green'
                            "
                            :type="
                              item.achievementStatus === 'DOWN'
                                ? 'arrow_down'
                                : 'arrow_up'
                            "
                          />
                          <div
                            class="data_detil"
                            :style="
                              item.achievementStatus === 'DOWN'
                                ? 'color: red'
                                : 'color:green'
                            "
                          >
                            {{ item.achievement }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="m-t-10 m-b-25" style="color: #4e4e4e">
                      {{ item.description }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-header">
                  <div class="container-header">
                    <div class="text">
                      <h6 class="title">NET ZERO ASPIRATION</h6>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div
                    v-for="(item, id) in dataNetZero"
                    :key="id"
                    class="card card_white mb_12"
                  >
                    <div class="sub_title_2">{{ item.metricName }}</div>
                    <div
                      style="justify-content: space-between"
                      class="d-flex align-items-center"
                    >
                      <div class="data_text">{{ item.value }}</div>
                      <div
                        style="flex: 1; text-align: right"
                        class="d-flex ms-2"
                      >
                        <div
                          v-if="item.achievement !== null"
                          class="d-inline-flex align-items-center me-2"
                          :class="
                            item.achievementStatus === 'DOWN'
                              ? 'badge_red'
                              : 'badge_green'
                          "
                        >
                          <IconSvg
                            :color="
                              item.achievementStatus === 'DOWN'
                                ? 'red'
                                : 'green'
                            "
                            :type="
                              item.achievementStatus === 'DOWN'
                                ? 'arrow_down'
                                : 'arrow_up'
                            "
                          />
                          <div
                            class="data_detil"
                            :style="
                              item.achievementStatus === 'DOWN'
                                ? 'color: red'
                                : 'color:green'
                            "
                          >
                            {{ item.achievement }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="m-t-10 m-b-25" style="color: #4e4e4e">
                      {{ item.description }}
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="row starter-main">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="container-header">
              <img
                class="img-fluid for-light m-r-20"
                src="@/assets/images/svg-img/finance-coin.svg"
                alt=""
              />
              <div class="text">
                <h5 class="title">MILESTONE TIMELINE</h5>
                <span class="subtitle">Last Updated: Yesterday</span>
              </div>
            </div>
            <div class="text m-t-20">
              Milestone Status
              <span
                class="m-r-5"
                style="
                  border-radius: 10px;
                  padding: 1%;
                  color: white;
                  background-color: #00aa4e;
                "
                >Done</span
              >
              <span
                class="m-r-5"
                style="
                  border-radius: 10px;
                  padding: 1%;
                  color: white;
                  background-color: #ff0b0b;
                "
                >Overdue</span
              >
              <span
                class="m-r-5"
                style="
                  border-radius: 10px;
                  padding: 1%;
                  color: white;
                  background-color: #92caf8;
                "
                >Due by next week</span
              >
              <span
                class="m-r-5"
                style="
                  border-radius: 10px;
                  padding: 1%;
                  color: white;
                  background-color: #8099d9;
                "
                >Due this month</span
              >
              <span
                class="m-r-5"
                style="
                  border-radius: 10px;
                  padding: 1%;
                  color: white;
                  background-color: #c892f8;
                "
                >Due after this month</span
              >
              <span
                style="
                  width: 10px;
                  height: 10px;
                  border-radius: 50%;
                  background-color: #f9f3ff;
                  color: #f9f3ff;
                  margin-right: 5px;
                "
              >
                ...</span
              >
              <span>Milestone</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="card-body">
                <MilestoneTimeline
                  :dataMilestoneTimeline="dataMilestoneTimeline"
                  :seriesMile="seriesMile"
                  :statusGreen="statusGreen"
                  :statusRed="statusRed"
                  :statusBlue="statusBlue"
                  :statusNav="statusNav"
                  :statusPurple="statusPurple"
                  :optionsMile="optionsMile"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row starter-main">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="container-header">
              <img
                class="img-fluid for-light m-r-20"
                src="@/assets/images/svg-img/finance-coin.svg"
                alt=""
              />
              <div class="text">
                <h5 class="title">MOONSHOT AND MILESTONE</h5>
                <span class="subtitle">Last Updated: Yesterday</span>
              </div>
            </div>
          </div>
          <MilestoneMoonshot
            :growth="growth"
            :digital="digital"
            :nze="nze"
            :dataImpact="dataImpact"
            :launchpad="launchpad"
            @editTimeline="editTimelines"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>
<script>
import IconSvg from "@/components/IconSvg.vue";
import ImpactComponent from "../cards/ImpactComponent.vue";
import MilestoneTimeline from "../cards/MilestoneTimeline.vue";
import MilestoneMoonshot from "../cards/MilestoneMoonshot.vue";
import MoonshotService from "@/services/moonshot/moonshot";

import { toRaw } from "vue";
const getMoonshot = MoonshotService.build();
export default {
  components: {
    IconSvg,
    ImpactComponent,
    MilestoneTimeline,
    MilestoneMoonshot,
  },
  data() {
    return {
      detailDetail: "",
      idDirectorate: "1",
      dataDirectorate: [
        { value: "1", label: "Directorate - Overall" },
        { value: "2", label: "Dir Keuangan" },
        { value: "3", label: "Dir MRD" },
      ],
      dataMilestoneTimeline: [],
      statusGreen: [],
      statusRed: [],
      statusBlue: [],
      statusNav: [],
      statusPurple: [],
      growth: [],
      digital: [],
      nze: [],
      launchpad: [],
      dataMoonshotMilestone: [],
      dataMilestoneTotal: [],

      dataImpact: [],
      seriesMile: [
        {
          name: "Series 1",
          data: [
            {
              x: 1,
              y: 1,
            },
            {
              x: 2,
              y: 1,
            },
            {
              x: 3,
              y: 3,
            },
            {
              x: 4,
              y: 8,
            },
            {
              x: 5,
              y: 6,
            },
            {
              x: 6,
              y: 7,
            },
            {
              x: 7,
              y: 2,
            },
            {
              x: 8,
              y: 3,
            },
            {
              x: 9,
              y: 3,
            },
            {
              x: 10,
              y: 3,
            },
            {
              x: 11,
              y: 3,
            },
            {
              x: 12,
              y: 3,
            },
          ],
        },
      ],
      dataImproved: [],
      dataNetZero: [],
      financialId: "MF_EBITDA",
      optionsMile: {
        chart: {
          background: "#F9F3FF",
          toolbar: {
            show: false,
          },
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        type: "scatter",
        // fill: {
        //   gradient: {
        //     shade: "light",
        //     type: "horizontal",
        //     shadeIntensity: 0.4,
        //     inverseColors: false,
        //     opacityFrom: 1,
        //     opacityTo: 0.7,
        //     stops: [0, 50],
        //   },
        // },
        colors: ["#7064F5", "#92CAF8", "#51bb25", "#544fff"],
        title: {
          // text: "Simple Bubble Chart",
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "Mei",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          lines: {
            show: true,
          },
        },
        grid: {
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        yaxis: {
          show: false,
          lines: {
            show: true,
          },
        },
      },
      isChecked: true,
      isChecked1: true,
      isChecked2: true,
      isChecked3: true,
      isChecked4: true,
      isActiveMonth: false,
      isActiveCumulative: false,
      isActive: false,
      title: "Finance",
      desc: [{ childMsg: "Foo" }, { childMsg: "Bar" }],
      options3: {
        chart: {
          type: "rangeBar",
          height: 350,
          width: "100%",
          toolbar: {
            show: false,
          },
        },
        legend: {
          show: true,
          position: "top",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            rangeBarGroupRows: true, // Stacked layout
          },
        },
        xaxis: {
          type: "category",
          labels: {
            rotate: -45,
            formatter: function (val) {
              return val; // You can format x-axis labels here if needed
            },
          },
        },
        yaxis: {
          title: {
            // text: "Range",
          },
        },
        title: {
          text: "EBITDA Impact Pipeline (IDR Bn)",
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val; // You can format tooltip values here if needed
            },
          },
        },
      },
      series3: [
        {
          name: "At Risk",
          data: [
            { x: "S1", y: [10, 30] }, // Each data point consists of [min, max]
            { x: "S2", y: [20, 40] },
            { x: "S3", y: [15, 35] },
            { x: "S4", y: [10, 15] },
            { x: "Total", y: [10, 15] },
            // Add more data points as needed
          ],
        },
        {
          name: "On Track",
          data: [
            { x: "S1", y: [20, 30] },
            { x: "S2", y: [30, 40] },
            { x: "S3", y: [25, 35] },
            { x: "S4", y: [15, 25] },
            { x: "Total", y: [15, 25] },
            // Add more data points as needed
          ],
        },
        {
          name: "Archieved",
          data: [
            { x: "S1", y: [30, 50] },
            { x: "S2", y: [40, 60] },
            { x: "S3", y: [35, 55] },
            { x: "S4", y: [25, 45] },
            { x: "Total", y: [25, 55] },
            // Add more data points as needed
          ],
        },
      ],
      dataProfit: [
        {
          title: "Cash Balance (IDR)",
          value: "441.1 Tn",
          percent1: "+1.2",
          percent2: "+3.2",
          totalPercent: "",
        },
        {
          title: "Potential cash needs (IDR)",
          value: "441.1 Tn",
          percent1: "+1.2",
          percent2: "+3.2",
          totalPercent: "87.5% of Revenue",
        },
        {
          title: "Interest bearing debt to invested capital",
          value: "441.1 Tn",
          percent1: "+1.2",
          percent2: "+3.2",
          totalPercent: "87.5% of Revenue",
        },
      ],
      leftChart: [
        {
          title: "Revenue (IDR)",
          value: "441.1 Tn",
          percent1: "+1.2",
          percent2: "+3.2",
          totalPercent: "",
        },
        {
          title: "Biaya pokok penyediaan (BPP) (IDR)",
          value: "441.1 Tn",
          percent1: "+1.2",
          percent2: "+3.2",
          totalPercent: "87.5% of Revenue",
        },
        {
          title: "Gross profit (IDR)",
          value: "441.1 Tn",
          percent1: "+1.2",
          percent2: "+3.2",
          totalPercent: "87.5% of Revenue",
        },
        {
          title: "Gain/loss on foreign exchange (IDR)",
          value: "441.1 Tn",
          percent1: "+1.2",
          percent2: "+3.2",
          totalPercent: "87.5% of Revenue",
        },
        {
          title: "Finance cost (IDR)",
          value: "441.1 Tn",
          percent1: "+1.2",
          percent2: "+3.2",
          totalPercent: "87.5% of Revenue",
        },
        {
          title: "Net profit (IDR)",
          value: "441.1 Tn",
          percent1: "+1.2",
          percent2: "+3.2",
          totalPercent: "87.5% of Revenue",
        },
        {
          title: "Revenue (IDR)",
          value: "441.1 Tn",
          percent1: "+1.2",
          percent2: "+3.2",
          totalPercent: "87.5% of Revenue",
        },
      ],
      options4: {
        chart: {
          width: 120,
          height: 120,
          type: "line",
          toolbar: {
            show: false,
          },
          offsetY: 10,
          dropShadow: {
            enabled: true,
            enabledOnSeries: undefined,
            top: 6,
            left: 0,
            blur: 6,
            color: "#00a3e9",
            opacity: 0.3,
          },
        },
        grid: {
          show: false,
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "horizontal",
            shadeIntensity: 1,
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            colorStops: [
              {
                offset: 0,
                color: "red",
                opacity: 1,
              },
              {
                offset: 20,
                color: "red",
                opacity: 1,
              },
              {
                offset: 30,
                color: "#b377d0",
                opacity: 1,
              },
              {
                offset: 65,
                color: "#7064f5",
                opacity: 1,
              },
              {
                offset: 70,
                color: "#b778cf",
                opacity: 1,
              },
              {
                offset: 80,
                color: "red",
                opacity: 1,
              },
              {
                offset: 100,
                color: "#a873d7",
                opacity: 1,
              },
            ],
          },
        },
        colors: ["var(--theme-deafult)"],
        stroke: {
          width: 2,
          curve: "smooth",
        },
        labels: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep"],
        markers: {
          size: 0,
        },
        xaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
          },
        },
        legend: {
          show: false,
        },
        tooltip: {
          marker: {
            show: false,
          },
          x: {
            show: false,
          },
          y: {
            show: false,
            labels: {
              show: false,
            },
          },
        },
        responsive: [
          {
            breakpoint: 1790,
            options: {
              chart: {
                width: 100,
                height: 100,
              },
            },
          },
          {
            breakpoint: 1661,
            options: {
              chart: {
                width: "100%",
                height: 100,
              },
            },
          },
        ],
      },
      series4: [
        {
          name: "Sales",
          data: [23, 23, 20, 20, 32, 32, 40, 32, 32, 25, 30, 30],
        },
      ],
    };
  },
  computed: {
    rawSeries() {
      return toRaw(this.series3);
    },
  },
  created() {
    // this.getDataBubble();
    // this.getFinancialImpact();
    // this.getDataImprovement();
    // this.getDataNetZero();
    this.getDataMoonshotMilestoneTimeline();
    this.getDataImpactChart();
    this.getDataMoonshotMilestone();
    this.getAllDataFinancial();
    this.getAllDataImprovement();
    this.getAllDataNetZero();
  },
  mounted() {
    this.$store.commit("updateJudulHalaman", "");
  },
  methods: {
    editTimelines(x) {
      this.detailDetail = x;
    },
    async getDataMoonshotMilestoneTimeline() {
      const param = {
        directorate: "all",
      };
      const res = await getMoonshot.getDataMoonshotMilestoneTimeline(param);
      const data = res.data.data;
      const grow = data.filter((item) => item.parent === "growth");
      const digital = data.filter((item) => item.parent === "digital");
      const nze = data.filter((item) => item.parent === "nze");
      const launch = data.filter((item) => item.parent === "launchpad");
      const total = data.filter((item) => item.parent === "Total");
      const statusGreen = [
        grow[0].status1,
        digital[0].status1,
        nze[0].status1,
        launch[0].status1,
        total[0].status1,
      ];
      const statusRed = [
        grow[0].status2,
        digital[0].status2,
        nze[0].status2,
        launch[0].status2,
        total[0].status2,
      ];
      const statusBlue = [
        grow[0].status3,
        digital[0].status3,
        nze[0].status3,
        launch[0].status3,
        total[0].status3,
      ];
      const statusNav = [
        grow[0].status4,
        digital[0].status4,
        nze[0].status4,
        launch[0].status4,
        total[0].status4,
      ];
      const statusPurple = [
        grow[0].status5,
        digital[0].status5,
        nze[0].status5,
        launch[0].status5,
        total[0].status5,
      ];
      this.statusGreen = statusGreen;
      this.statusRed = statusRed;
      this.statusBlue = statusBlue;
      this.statusNav = statusNav;
      this.statusPurple = statusPurple;
      this.dataMilestoneTimeline = {
        grow: grow[0].total,
        digital: digital[0].total,
        nze: nze[0].total,
        launch: launch[0].total,
        total: total[0].total,
      };
      const filteredGrow = grow.reduce((acc, obj) => {
        const filteredEntries = Object.entries(obj).filter(
          ([key, value]) =>
            key !== "parent" &&
            key !== "total" &&
            key !== "status1" &&
            key !== "status2" &&
            key !== "status3" &&
            key !== "status4" &&
            key !== "status5"
        );
        filteredEntries.forEach(([key, value]) => {
          acc.push({ x: value !== 0 ? 1 : 0, y: 7 });
        });
        return acc;
      }, []);
      const filteredDig = digital.reduce((acc, obj) => {
        const filteredEntries = Object.entries(obj).filter(
          ([key, value]) =>
            key !== "parent" &&
            key !== "total" &&
            key !== "status1" &&
            key !== "status2" &&
            key !== "status3" &&
            key !== "status4" &&
            key !== "status5"
        );
        filteredEntries.forEach(([key, value]) => {
          acc.push({ x: value !== 0 ? 1 : 0, y: 5 });
        });
        return acc;
      }, []);
      const filteredNze = nze.reduce((acc, obj) => {
        const filteredEntries = Object.entries(obj).filter(
          ([key, value]) =>
            key !== "parent" &&
            key !== "total" &&
            key !== "status1" &&
            key !== "status2" &&
            key !== "status3" &&
            key !== "status4" &&
            key !== "status5"
        );
        filteredEntries.forEach(([key, value]) => {
          acc.push({ x: value !== 0 ? 1 : 0, y: 3 });
        });
        return acc;
      }, []);
      const filteredLaunch = launch.reduce((acc, obj) => {
        const filteredEntries = Object.entries(obj).filter(
          ([key, value]) =>
            key !== "parent" &&
            key !== "total" &&
            key !== "status1" &&
            key !== "status2" &&
            key !== "status3" &&
            key !== "status4" &&
            key !== "status5"
        );
        filteredEntries.forEach(([key, value]) => {
          acc.push({ x: value !== 0 ? 1 : 0, y: 1 });
        });
        return acc;
      }, []);
      // this.seriesMile = [
      //   {
      //     name: "Grow",
      //     data: filteredGrow,
      //   },
      //   {
      //     name: "Digital",
      //     data: filteredDig,
      //   },
      //   {
      //     name: "NZE",
      //     data: filteredNze,
      //   },
      //   {
      //     name: "Launchpad",
      //     data: filteredLaunch,
      //   },
      // ];
    },
    async getAllDataImprovement() {
      const param = {
        directorate: "Overall",
        target: "MOONSHOT_IMPROVEMENT",
      };
      const res = await getMoonshot.getAllData(param);
      const data = res.data.data;
      this.dataImproved = data;
    },
    async getAllDataNetZero() {
      const param = {
        directorate: "Overall",
        target: "MOONSHOT_NET_ZERO",
      };
      const res = await getMoonshot.getAllData(param);
      const data = res.data.data;
      this.dataNetZero = data;
    },
    handleFormSubmitted(data) {
      this.financialId = data;
      this.getDataImpactChart();
    },
    async getAllDataFinancial() {
      const param = {
        directorate: "Overall",
        target: "MOONSHOT_FINANCIAL",
      };
      const res = await getMoonshot.getAllData(param);
      const data = res.data.data;
      this.dataImpact = data;
      setTimeout(() => {
        this.$refs.childComponent.getData();
      }, 100);
    },
    async getDataMoonshotMilestone() {
      const paramg = {
        directorate: "consolidated",
        type: "MM_GROWTH",
      };
      const resg = await getMoonshot.getDataMoonshotMilestoneV2(paramg);
      const datag = resg.data.data.dataInitiatives;
      const paramd = {
        directorate: "consolidated",
        type: "MM_DIGITAL",
      };
      const resd = await getMoonshot.getDataMoonshotMilestoneV2(paramd);
      const datad = resd.data.data.dataInitiatives;
      const paramn = {
        directorate: "consolidated",
        type: "MM_NZE",
      };
      const resn = await getMoonshot.getDataMoonshotMilestoneV2(paramn);
      const datan = resn.data.data.dataInitiatives;
      const paraml = {
        directorate: "consolidated",
        type: "MM_LAUNCHPAD",
      };
      const resl = await getMoonshot.getDataMoonshotMilestoneV2(paraml);
      const datal = resl.data.data.dataInitiatives;

      this.growth = datag;
      this.digital = datad;
      this.nze = datan;
      this.launchpad = datal;
    },
    async getDataImpactChart() {
      const param = {
        directorate: "consolidated",
        financial: this.financialId,
        period: "current",
      };
      const res = await getMoonshot.getDataImpactChart(param);
      const data = res.data.data;
      const risk = data.map((obj) => obj.atRisk);
      const onTrack = data.map((obj) => obj.onTrack);
      const achieved = data.map((obj) => obj.achieved);
      const chart = [
        {
          name: "At Risk",
          data: [
            { x: "S1", y: [0, risk[0]] }, // Each data point consists of [min, max]
            { x: "S2", y: [0, risk[1]] },
            { x: "S3", y: [0, risk[2]] },
            { x: "S4", y: [0, risk[3]] },
            { x: "Total", y: [0, risk[5]] },
            // Add more data points as needed
          ],
        },
        {
          name: "On Track",
          data: [
            { x: "S1", y: [0, onTrack[0]] },
            { x: "S2", y: [0, onTrack[1]] },
            { x: "S3", y: [0, onTrack[2]] },
            { x: "S4", y: [0, onTrack[3]] },
            { x: "Total", y: [0, onTrack[4]] },
            // Add more data points as needed
          ],
        },
        {
          name: "Archieved",
          data: [
            { x: "S1", y: [0, achieved[0]] },
            { x: "S2", y: [0, achieved[1]] },
            { x: "S3", y: [0, achieved[2]] },
            { x: "S4", y: [0, achieved[3]] },
            { x: "Total", y: [0, achieved[4]] },
            // Add more data points as needed
          ],
        },
      ];
      this.series3 = chart;
    },
    async getDataNetZero() {
      const res = await getMoonshot.getDataImprovement();
      const data = res.data.data;
      this.dataNetZero = data;
    },
    async getDataImprovement() {
      const res = await getMoonshot.getDataImprovement();
      const data = res.data.data;
      this.dataImproved = data;
    },
    async getFinancialImpact() {
      const res = await getMoonshot.getFinancialImpact();
      const data = res.data.data;
      this.dataImpact = data;
    },
    generateData(baseval, count, yrange) {
      var i = 0;
      var series = [];
      while (i < count) {
        var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
        var y =
          Math.floor(Math.random() * (yrange.max - yrange.min + 1)) +
          yrange.min;
        var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;

        series.push([x, y, z]);
        baseval += 86400000;
        i++;
      }
      return series;
    },
    getDataBubble() {
      this.seriesMile = [
        {
          name: "Bubble 1",
          data: [
            { x: new Date("2024-04-01").getMonth(), y: 10, z: 10 },
            { x: new Date("2024-04-02").getMonth(), y: 10, z: 10 },
            { x: new Date("2024-04-03").getMonth(), y: 10, z: 10 },
          ],
        },
        {
          name: "Bubble 1",
          data: [{ x: new Date("2024-06-01").getMonth(), y: 20, z: 30 }],
          data: [{ x: new Date("2024-04-01").getMonth(), y: 20, z: 30 }],
          data: [{ x: new Date("2024-06-01").getMonth(), y: 20, z: 30 }],
        },
        {
          name: "Bubble 1",
          data: [{ x: new Date("2024-03-01").getMonth(), y: 30, z: 30 }],
        },
        {
          name: "Bubble 1",
          data: [{ x: new Date("2024-05-01").getMonth(), y: 30, z: 30 }],
        },
        {
          name: "Bubble 1",
          data: [{ x: new Date("2024-08-01").getMonth(), y: 30, z: 30 }],
        },
      ];
    },
    detailCash() {
      this.$router.push({ name: "detail-cash" });
    },
    more() {
      this.$router.push({ name: "detail-assets" });
    },
    profit() {
      this.$router.push({ name: "detail-profit" });
    },
    monthly() {
      this.isActiveMonth = !this.isActiveMonth;
    },
    cumulative() {
      this.isActiveCumulative = !this.isActiveCumulative;
    },
    toggleSwitch() {
      this.isActive = !this.isActive;
    },
  },
};
</script>
<style scoped>
#logo-holder {
  position: relative;
}
#logo-holder .image,
#logo-holder .texts {
  transition: opacity 0.5s ease-in-out;
}
#logo-holder .image1,
#logo-holder .text1 {
  transition: opacity 0.5s ease-in-out;
}
#logo-holder .texts {
  position: absolute;
  font-size: 12px;
  top: 10px;
  left: 30px;
  opacity: 0;
}
#logo-holder .text1 {
  position: absolute;
  font-size: 12px;
  top: 10px;
  left: 90px;
  opacity: 0;
}

#logo-holder:hover .image {
  opacity: 1;
  margin-left: 60px;
}
#logo-holder:hover .image1 {
  opacity: 1;
  margin-left: 30px;
}
#logo-holder:hover .texts {
  opacity: 1;
  background-color: green;
  color: white;
  margin-right: 10px;
}
#logo-holder:hover .text1 {
  opacity: 1;
  background-color: green;
  color: white;
  margin-left: 7px;
}
.font-gray {
  color: #4e4e4e !important;
}
.title-left {
  white-space: normal;
  width: 155px;
}
.left-card {
  border: 1px solid #e5e7ed;
  border-radius: 8px;
  background-color: white;
  margin-bottom: 10px;
}
.title-chart-right {
  color: #4e4e4e;
  font-weight: bold;
}
.header-right-chart {
  display: inline-flex;
  width: 100%;
  justify-content: space-between;
}
.custom-dropdown {
  background-color: #e6e6e6; /* Set the background color to gray */
  padding: 8px; /* Add padding for better appearance */
  border: none; /* Remove default border */
  border-radius: 4px; /* Add border radius for rounded corners */
  outline: none; /* Remove focus outline */
  /* Add any additional styles here */
}
/* .checkbox1 {
  background-color: #92caf8;
} */
.checkbox1 {
  display: none; /* Hide the default checkbox */
}

/* Style the label associated with the custom checkbox */
.checkbox1 + label {
  position: relative;
  padding-left: 25px; /* Adjust the padding to accommodate the custom checkbox */
  cursor: pointer;
}

/* Style the custom checkbox */
.checkbox1 + label::before {
  content: "";
  display: inline-block;
  width: 18px;
  height: 18px;
  background-color: #e0e0e0; /* Background color of the custom checkbox */
  border: 1px solid #ccc; /* Border color */
  border-radius: 4px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

/* Change background color when checked */
.checkbox1:checked + label::before {
  background-color: #92caf8; /* Background color when checked */
}
.container-cash-cart {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 0px;
}
.item {
  width: 48%; /* Each div takes up 50% of the container width */
}
.text-detail:hover {
  color: #16c7f9;
}
.fa.fa-angle-right {
  color: #16c7f9;
}
.btn-disable {
  background-color: #e9e9e9;
}
.profit-card {
  /* justify-content: center; */
  padding: 2%;
}
</style>
